export default function CourseOverview({ data }) {
  const stripHtml = (html) => {
    if (!html) return "";
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };
  return (
    <div className="space-y-6 font-inter">
      {/* ================= Course Overview ================= */}
      <div className="bg-white border rounded-2xl p-6 relative">
        <h3 className="text-[#572575] flex items-center gap-2 font-bold text-lg mb-5">
          <img src="/courseDetails/CO.png" alt="CO" className="h-5 w-5" />{" "}
          Course Overview
        </h3>

        <div className="grid grid-cols-2 gap-x-12 gap-y-6 text-[13px]">
          <Info label="Course Name" value={data.courseDetails.course_name} />
          <Info label="Course Level" value={data.courseDetails.course_level} />
          <Info
            label="Course Broad Field"
            value={data.courseDetails.broad_field_name}
          />
          <Info
            label="Course Narrow Field"
            value={data.courseDetails.narrow_field_name}
          />
          <Info label="Duration" value={data.courseDetails.course_duration} />
          <Info
            label="Specialization"
            value={data.courseDetails.specialization}
          />
        </div>

        <img
          src="/icons/grad-cap.svg"
          alt=""
          className="absolute right-6 top-10 w-24 opacity-80"
        />
      </div>

      {/* ================= Careers Prospect ================= */}
      <div className="bg-white border rounded-2xl p-6">
        <h3 className="text-[#572575] flex items-center gap-2 font-bold text-lg mb-5">
          <img
            src="/courseDetails/Basket.png"
            alt="Basket"
            className="h-5 w-5"
          />{" "}
          Career Prospect
        </h3>

        <div className="grid grid-cols-2 gap-6 text-[13px]">
          <Info
            label="Job Industry"
            value={data.courseDetails.job_industries}
          />
          <Info
            label="Average Salary"
            value={data.courseDetails.average_salary}
          />
        </div>
      </div>

      {/* ================= Careers Outcomes ================= */}
      <div className="bg-white border rounded-2xl p-6">
        <h3 className="text-[#572575] flex items-center gap-2 font-bold text-lg mb-5">
          <img
            src="/courseDetails/Basket.png"
            alt="Basket"
            className="h-5 w-5"
          />{" "}
          Careers Outcomes
        </h3>

        <div className="flex flex-wrap gap-3">
          {data.courseDetails.career_outcomes?.split("|").map((item, index) => (
            <span
              key={index}
              className="px-4 py-2 text-[12px] border rounded-xl text-black font-semibold bg-[#FFEEE5]"
            >
              {item.trim()}
            </span>
          ))}
        </div>
      </div>

      {/* ================= Available Application Intakes ================= */}
      <div className="bg-white border rounded-2xl p-6">
        <h3 className="text-[#572575] flex items-center gap-2 font-bold text-lg mb-5">
          <img
            src="/courseDetails/Basket.png"
            alt="Basket"
            className="h-5 w-5"
          />{" "}
          Available Application Intakes
        </h3>

        <div className="overflow-x-auto">
          <table className="w-full text-[13px] border-collapse rounded-lg">
            <thead>
              <tr className="bg-[#F9EEFF80] text-[#572575] border border-[#E2BFF5] rounded-t-lg">
                <th className="text-left p-3 font-semibold">Intakes</th>
                <th className="text-left p-3 font-semibold">Early Deadline</th>
                <th className="text-left p-3 font-semibold">
                  Regular Deadline
                </th>
              </tr>
            </thead>
            <tbody className="font-semibold">
              {data.courseDetails.IntakeFrom_Year?.split("|").map(
                (item, idx) => (
                  <tr key={idx} className="border border-gray-200">
                    <td className="p-3">{item}</td>
                    <td className="p-3 text-red-500 ">
                      03 aug'24 to 10 aug'24
                    </td>
                    <td className="p-3 text-red-500">
                      {data.courseDetails.regular_application_deadline}
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ================= Scholarship Overview ================= */}
      <div className="bg-white border rounded-2xl p-6 relative">
        <h3 className="text-[#572575] flex items-center gap-2 font-bold text-lg mb-5">
          <img src="/courseDetails/SO.png" alt="Basket" className="h-5 w-5" />{" "}
          Scholarship Overview
        </h3>

        <div className="grid grid-cols-2 gap-x-12 gap-y-5 text-[13px]">
          <Info
            label="Scholarships Available"
            value={data.courseDetails.scholarship === 1 ? "Yes" : "No"}
          />
          <Info
            label="Application TAT (In Days)"
            value={data.courseDetails.application_tat}
          />
          <Info
            label="Course Broad Field"
            value={data.courseDetails.broad_field_name}
          />
          <Info
            label="NACES Evaluation Required"
            value={data.courseDetails.naces}
          />
          <Info label="CPT" value={data.courseDetails.cpt} />
          <Info label="STEM" value={data.courseDetails.stem} />
        </div>

        <img
          src="/icons/scholarship.svg"
          alt=""
          className="absolute right-6 bottom-6 w-24 opacity-80"
        />

        {/* Scholarship Criteria */}
        <div className="mt-6 p-4 bg-[#FFFCF5] rounded-lg border-5 border-l border-[#BE7603]">
          <p className="text-[#BE7603] font-semibold text-lg mb-2">
            Scholarship Criteria :
          </p>
          <p className="text-sm text-black leading-relaxed">
            {stripHtml(data.courseDetails.scholarship_criteria)}
          </p>
        </div>
      </div>
    </div>
  );
}

/* ================= Reusable Info Row ================= */
function Info({ label, value }) {
  return (
    <div>
      <p className="text-gray-400 mb-1">{label}</p>
      <p className="font-semibold text-gray-800">{value}</p>
    </div>
  );
}
